import React, {useState, useEffect, useCallback, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import FilterLayout from '../FilterLayout';
import RowLayout from '../../../components/Layouts/RowLayout';
import SMCExpansionPanel from '../../../components/Simple/SMCExpansionPanel';
import SMCIcon from '../../../components/Simple/SMCIcon';
import {SMCSelect, SMCOption} from '../../../components/Simple/SMCSelect';
import Api from '../../../api/SMPFetchHelper';
import {ServiceDomainFilterSchema} from '../../../api/DBSchema/ServiceDomain';
import { SessionDataGetSchema } from '../../../api/DBSchema/SessionData';



function ServiceDomainFilterPane({
    initialFilter,
    onFilterChange,
    open
}) {
    const { t } = useTranslation();
    const didMountRef = useRef(true);


    const [availableServerGroups, setAvailableServerGroups] = useState(null);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [/*pageError*/, setPageError] = useState(false);

    const [serverGroups, setServerGroups] = useState('');

        
    

    const resetToDefaults = useCallback(() => {
        setServerGroups('');
    }, []);


    // Update filter request object on value change
    useEffect(() => {
        // Don't run on first render
        if (didMountRef.current === true) {
            didMountRef.current = false;
            return;
        }

        const filterRequestObj = {};
      
        // serverGroup
        if (serverGroups) {
            filterRequestObj[ServiceDomainFilterSchema.serverGroups] = { value: serverGroups };
        }
        
        onFilterChange(filterRequestObj);
    }, [
         onFilterChange, serverGroups
    ]);

    useEffect(() => {
        (async () => {
            try {
                const sessionDataResp = await Api.getSessionData({
                    attributes: [SessionDataGetSchema.availableServerGroups
                        ]
                });
                setAvailableServerGroups(sessionDataResp.data.availableServerGroups);
            } catch (e) {
                console.error('ServiceDomainFilterPane: error reading availableServerGroups', e);
                setPageError(true);
            }
            setPageLoaded(true);
        })();
    }, []);


    return (
        <FilterLayout clearAllAction={resetToDefaults} loading={!pageLoaded}>
            {/* Server Group tab */}
            <SMCExpansionPanel title={t('SMC_SERVICE_DOMAIN_SERVER_GROUP')}>
                <RowLayout spacing={5}>
                    <SMCSelect
                        value={serverGroups}
                        onChange={e => setServerGroups(e.target.value)}
                        inline
                        width="150px"
                    >
                        <SMCOption value="" />
                        {
                            availableServerGroups && availableServerGroups.map(serverGroupName => (
                                <SMCOption key={serverGroupName} value={serverGroupName}>{serverGroupName}</SMCOption>
                            ))
                        }
                    </SMCSelect>
                    <SMCIcon icon="clear" onClick={() => setServerGroups('')} />
                </RowLayout>
            </SMCExpansionPanel>
        </FilterLayout>
    );
}

export default React.memo(ServiceDomainFilterPane);
